import React, { FunctionComponent } from "react";
import { Card } from "@vwfs-bronson/bronson-react";
import { Output } from "../../../Text";
import { formatEuroAmount } from "../../../functional/normalize";
import DescriptionListRender from "../../../common/components/DescriptionListRender/DescriptionListRender";

export type DespositTransferProps = {
  originSystem: string;
  prefill: any;
};

const DepositTransfer: FunctionComponent<DespositTransferProps> = (props) => {
  let { originSystem, prefill } = props;
  const currency = Output.resolve("generic.currencySymbol");
  const descriptionList = Output.resolve(
    `pages.signatureSuccess.${originSystem}.depositTransfer.descriptionList`
  );

  const depositTransferData = [
    `${formatEuroAmount(
      prefill?.financialProduct?.calculation?.downPaymentAmount
    )} ${currency}`,
    Output.resolve(
      `pages.signatureSuccess.${originSystem}.depositTransfer.paymentType`
    ),
    Output.resolve(
      `pages.signatureSuccess.${originSystem}.depositTransfer.accountOwner`
    ),
    prefill?.dealerData?.paymentData?.iban,
    prefill?.dealerData?.paymentData?.bic,
    prefill?.vehicleData?.vin,
  ];

  return (
    <Card
      title={Output.resolve(
        `pages.signatureSuccess.${originSystem}.depositTransfer.title`
      )}
      className="u-text-left"
    >
      <DescriptionListRender
        descriptionList={descriptionList}
        descriptionListData={depositTransferData}
      />
    </Card>
  );
};

export default DepositTransfer;
